import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from '@/auth/msalConfig'
import { AuthGate } from '@/auth/AuthGate'
import { Shell } from '@/app/Shell'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})

const msal = new PublicClientApplication(msalConfig)

// IIFE — avoids top-level await, which isn't in Vite's default build target.
;(async () => {
  await msal.initialize()
  // Handle any in-flight Entra redirect (loginRedirect / acquireTokenRedirect
  // come back as ?code=... on this URL; MSAL needs to be told to process it
  // before useMsal() reports the signed-in account).
  await msal.handleRedirectPromise()
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msal}>
        <QueryClientProvider client={queryClient}>
          <AuthGate>
            <Shell />
          </AuthGate>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>,
  )
})()
